
import { defineComponent, ref } from 'vue';
import InputText from '@/components/input/InputText.vue';
import InputImage from '@/components/input/InputImageCostume.vue';
import InputCheckbox from '../input/InputCheckbox.vue';
import { useStore } from 'vuex';
import { POST_DONATION, PUT_DONATION } from "@/store/donasiTerahir.module";
import { POST_IMAGE } from "@/store/upload.module";
import InputCheckboxOptions from '../input/InputCheckboxOptions.vue';
import InputPrice from '../input/InputPrice.vue';
import InputDate from '../input/InputDate.vue';

export default defineComponent({
  components: {
    InputText,
    InputImage,
    InputCheckbox,
    InputCheckboxOptions,
    InputPrice,
    InputDate,
  },
  props: {
    title: {
      type: String,
      required: true
    },
    id:{
      type: String,
      required: false
    },
    data: {
      type: Object,
      required: false,
      default: () => ({}) // Provide a default object to prevent undefined errors
    }
  },
  setup(props, { emit }) {
    const store = useStore();
    const modalContent = ref(null);
    const isLoading = ref(false);

    const closeModal = () => {
      isLoading.value = false;
      emit('close');
    };

    const formData = {
      id: '',
      data: {} as Record<string, any>
    }

    const updateValue = (params: { key: string; value: any }) => {
      formData.data[params.key] = params.value;
    };

    const handleSubmit = async () => {
      isLoading.value = true;
      try {

        if(formData?.data?.image){
          if(typeof formData?.data?.image !== "string") {
            const response = await store.dispatch(POST_IMAGE, formData);
            formData.data.proof = response || "";
          }
          formData.data.proof = formData?.data?.image || "";
          delete formData.data?.image;
        }
        if(props?.id){
          formData.id = props?.id
          await store.dispatch(PUT_DONATION, formData);
        }else{
          await store.dispatch(POST_DONATION, formData);
        }
        closeModal();
      } catch (error:any) {
        alert(error?.response?.data?.message);
        isLoading.value = false;
      }
    };

    return {
      modalContent,
      closeModal,
      handleSubmit,
      updateValue,
      isLoading
    };
  },
});
